var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGooglePlay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 187,
    height: 54,
    viewBox: "0 0 187 54",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M179.752 54H6.91356C3.11283 54 0 50.9608 0 47.25V6.75003C0 3.03922 3.11283 3.5923e-05 6.91356 3.5923e-05H179.752C183.553 3.5923e-05 186.666 3.03922 186.666 6.75003V47.25C186.666 50.9608 183.553 54 179.752 54Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M179.752 1.08172C182.953 1.08172 185.558 3.62479 185.558 6.75003V47.25C185.558 50.3753 182.953 52.9183 179.752 52.9183H6.91356C3.71258 52.9183 1.1079 50.3753 1.1079 47.25V6.75003C1.1079 3.62479 3.71258 1.08172 6.91356 1.08172H179.752ZM179.752 3.5923e-05H6.91356C3.11283 3.5923e-05 0 3.03922 0 6.75003V47.25C0 50.9608 3.11283 54 6.91356 54H179.752C183.553 54 186.666 50.9608 186.666 47.25V6.75003C186.666 3.03922 183.553 3.5923e-05 179.752 3.5923e-05Z",
    fill: "#A6A6A6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5658 13.8294C65.5658 14.9566 65.2202 15.8594 64.5392 16.5327C63.7562 17.3309 62.7365 17.7326 61.4868 17.7326C60.2925 17.7326 59.2728 17.3242 58.4362 16.5192C57.598 15.7025 57.1797 14.7001 57.1797 13.5003C57.1797 12.3005 57.598 11.2981 58.4362 10.4881C59.2728 9.67644 60.2925 9.26807 61.4868 9.26807C62.0814 9.26807 62.6483 9.38788 63.1893 9.61063C63.7286 9.83507 64.1676 10.1388 64.4856 10.5134L63.7631 11.2256C63.2083 10.586 62.453 10.2704 61.4868 10.2704C60.6157 10.2704 59.8604 10.5674 59.2192 11.1665C58.5849 11.7673 58.2668 12.5452 58.2668 13.5003C58.2668 14.4554 58.5849 15.2401 59.2192 15.8409C59.8604 16.4332 60.6157 16.7369 61.4868 16.7369C62.4115 16.7369 63.1893 16.4332 63.8029 15.8341C64.2073 15.4376 64.4372 14.8908 64.4977 14.1922H61.4868V13.2168H65.5036C65.552 13.4278 65.5658 13.6319 65.5658 13.8294Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M71.9379 10.4475H68.1648V13.0125H71.5663V13.9879H68.1648V16.5529H71.9379V17.5469H67.0967V9.45361H71.9379V10.4475Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M76.4352 17.5469H75.367V10.4475H73.0527V9.45361H78.7512V10.4475H76.4352V17.5469Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M82.875 17.5469V9.45361H83.9414V17.5469H82.875Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M88.6686 17.5469H87.6091V10.4475H85.2861V9.45361H90.9915V10.4475H88.6686V17.5469Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M101.781 16.5057C100.964 17.3242 99.9511 17.7326 98.743 17.7326C97.5279 17.7326 96.5151 17.3242 95.6976 16.5057C94.8818 15.689 94.4756 14.6866 94.4756 13.5003C94.4756 12.314 94.8818 11.3116 95.6976 10.4949C96.5151 9.67644 97.5279 9.26807 98.743 9.26807C99.9442 9.26807 100.957 9.67644 101.775 10.5016C102.597 11.3251 103.003 12.3208 103.003 13.5003C103.003 14.6866 102.597 15.689 101.781 16.5057ZM96.4874 15.8274C97.1027 16.4332 97.8511 16.7369 98.743 16.7369C99.6279 16.7369 100.383 16.4332 100.992 15.8274C101.605 15.2216 101.916 14.4436 101.916 13.5003C101.916 12.557 101.605 11.7791 100.992 11.1733C100.383 10.5674 99.6279 10.2637 98.743 10.2637C97.8511 10.2637 97.1027 10.5674 96.4874 11.1733C95.8739 11.7791 95.5627 12.557 95.5627 13.5003C95.5627 14.4436 95.8739 15.2216 96.4874 15.8274Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M104.499 17.5464V9.45312H105.795L109.826 15.7475H109.873L109.826 14.1916V9.45312H110.892V17.5464H109.779L105.559 10.9415H105.512L105.559 12.5041V17.5464H104.499Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M94.2106 29.3659C90.963 29.3659 88.3099 31.779 88.3099 35.1085C88.3099 38.4109 90.963 40.8493 94.2106 40.8493C97.4652 40.8493 100.118 38.4109 100.118 35.1085C100.118 31.779 97.4652 29.3659 94.2106 29.3659ZM94.2106 38.5881C92.4287 38.5881 90.8956 37.152 90.8956 35.1085C90.8956 33.0379 92.4287 31.6272 94.2106 31.6272C95.9926 31.6272 97.5326 33.0379 97.5326 35.1085C97.5326 37.152 95.9926 38.5881 94.2106 38.5881ZM81.3359 29.3659C78.0813 29.3659 75.4352 31.779 75.4352 35.1085C75.4352 38.4109 78.0813 40.8493 81.3359 40.8493C84.5887 40.8493 87.2366 38.4109 87.2366 35.1085C87.2366 31.779 84.5887 29.3659 81.3359 29.3659ZM81.3359 38.5881C79.5522 38.5881 78.0139 37.152 78.0139 35.1085C78.0139 33.0379 79.5522 31.6272 81.3359 31.6272C83.1178 31.6272 84.6509 33.0379 84.6509 35.1085C84.6509 37.152 83.1178 38.5881 81.3359 38.5881ZM66.0154 31.126V33.5661H71.9836C71.809 34.9296 71.3423 35.932 70.6268 36.6306C69.7557 37.4743 68.3989 38.4109 66.0154 38.4109C62.3426 38.4109 59.4666 35.5168 59.4666 31.9309C59.4666 28.345 62.3426 25.4509 66.0154 25.4509C68.0014 25.4509 69.4463 26.2086 70.5127 27.1907L72.2739 25.4712C70.7823 24.0807 68.7981 23.0125 66.0154 23.0125C60.9789 23.0125 56.7461 27.0135 56.7461 31.9309C56.7461 36.8483 60.9789 40.8493 66.0154 40.8493C68.7377 40.8493 70.7823 39.9786 72.3897 38.3451C74.0369 36.7369 74.5502 34.4756 74.5502 32.6498C74.5502 32.0828 74.5018 31.5613 74.4154 31.126H66.0154ZM128.663 33.0177C128.177 31.7335 126.678 29.3659 123.626 29.3659C120.601 29.3659 118.083 31.693 118.083 35.1085C118.083 38.3248 120.575 40.8493 123.916 40.8493C126.618 40.8493 128.177 39.2411 128.818 38.3046L126.813 37.0001C126.144 37.9553 125.233 38.5881 123.916 38.5881C122.608 38.5881 121.67 38.0025 121.068 36.8483L128.934 33.6707L128.663 33.0177ZM120.643 34.9296C120.575 32.7156 122.404 31.5816 123.714 31.5816C124.741 31.5816 125.612 32.0828 125.902 32.8L120.643 34.9296ZM114.25 40.5H116.835V23.625H114.25V40.5ZM110.015 30.645H109.929C109.348 29.9734 108.24 29.3659 106.837 29.3659C103.891 29.3659 101.199 31.8904 101.199 35.127C101.199 38.3451 103.891 40.8493 106.837 40.8493C108.24 40.8493 109.348 40.2368 109.929 39.5449H110.015V40.3684C110.015 42.5638 108.814 43.7434 106.876 43.7434C105.297 43.7434 104.317 42.6296 103.912 41.6931L101.663 42.6094C102.312 44.1315 104.028 46.0046 106.876 46.0046C109.908 46.0046 112.466 44.2631 112.466 40.0258V29.7152H110.015V30.645ZM107.058 38.5881C105.276 38.5881 103.784 37.1318 103.784 35.127C103.784 33.1037 105.276 31.6272 107.058 31.6272C108.814 31.6272 110.198 33.1037 110.198 35.127C110.198 37.1318 108.814 38.5881 107.058 38.5881ZM140.768 23.625H134.584V40.5H137.163V34.1061H140.768C143.632 34.1061 146.441 32.0828 146.441 28.8647C146.441 25.6483 143.625 23.625 140.768 23.625ZM140.836 31.7588H137.163V25.9723H140.836C142.761 25.9723 143.86 27.5333 143.86 28.8647C143.86 30.1708 142.761 31.7588 140.836 31.7588ZM156.777 29.3338C154.913 29.3338 152.976 30.1371 152.179 31.9174L154.467 32.854C154.96 31.9174 155.866 31.6137 156.823 31.6137C158.161 31.6137 159.518 32.3983 159.539 33.7838V33.961C159.072 33.6977 158.073 33.3079 156.844 33.3079C154.379 33.3079 151.868 34.6326 151.868 37.1048C151.868 39.366 153.887 40.8223 156.156 40.8223C157.891 40.8223 158.849 40.0579 159.45 39.1686H159.539V40.473H162.029V33.9998C162.029 31.0078 159.741 29.3338 156.777 29.3338ZM156.465 38.5813C155.622 38.5813 154.447 38.173 154.447 37.152C154.447 35.8459 155.912 35.3447 157.181 35.3447C158.317 35.3447 158.849 35.5894 159.539 35.9117C159.336 37.4743 157.959 38.5813 156.465 38.5813ZM171.103 29.7034L168.139 37.0187H168.051L164.986 29.7034H162.205L166.81 39.9263L164.183 45.6148H166.877L173.972 29.7034H171.103ZM147.858 40.5H150.444V23.625H147.858V40.5Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4293 10.1774C14.0231 10.5925 13.7881 11.2389 13.7881 12.0759V41.9311C13.7881 42.7681 14.0231 43.4144 14.4293 43.8295L14.5296 43.9207L31.6648 27.1975V26.8027L14.5296 10.0795L14.4293 10.1774Z",
    fill: "url(#paint0_linear_2078_15817)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3685 32.7744L31.6631 27.1972V26.8024L37.3754 21.2252L37.5033 21.2977L44.2682 25.0558C46.1988 26.1223 46.1988 27.8773 44.2682 28.9505L37.5033 32.7018L37.3685 32.7744Z",
    fill: "url(#paint1_linear_2078_15817)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5054 32.7019L31.6652 26.9998L14.4297 43.8292C15.0709 44.4873 16.1166 44.5667 17.3057 43.9085L37.5054 32.7019Z",
    fill: "url(#paint2_linear_2078_15817)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5054 21.2977L17.3057 10.091C16.1166 9.43965 15.0709 9.51895 14.4297 10.1771L31.6652 26.9998L37.5054 21.2977Z",
    fill: "url(#paint3_linear_2078_15817)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2078_15817",
    x1: 30.1434,
    y1: 42.242,
    x2: 7.49367,
    y2: 19.0434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0066,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2078_15817",
    x1: 46.7822,
    y1: 26.9979,
    x2: 13.3249,
    y2: 26.9979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2078_15817",
    x1: 34.3297,
    y1: 23.9001,
    x2: 3.61479,
    y2: -7.55908,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2078_15817",
    x1: 10.0912,
    y1: 53.7619,
    x2: 23.8067,
    y2: 39.7141,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlay);
export default __webpack_public_path__ + "static/media/google-play.eda365b72e907120100d39a62103d85e.svg";
export { ForwardRef as ReactComponent };